import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Dynamic graphics',
  attributeName: 'dynamicGraphics',
  helpText: 'This section is to control how many and what content will appear in the Main Hub. It can be reorganized into different forms',
  fields: [
    // {
    //   attributeName: 'maxContainers',
    //   helpText: '(be aware when reducing the number of containers stablished), content is not deleted from db but It will disappear from layout',
    //   type: FormInputTypes.TEXT_INPUT.NUMBER,
    //   label: 'Number max of containers',
    //   min:3,
    //   max:7
    // },
    {
      attributeName: 'graphicsManifestURL',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Graphics Manifest URL',
      helpText: 'URL to the graphics manifest for the mainhub. To learn more about graphics manifest, please refer to the “Graphics Manifest” documentation.',
      fileType: ['.json'],
    },
  ],
};
